import { FollowingComponent, ProfileComponent, BookingListComponent } from "components";
import SellerDashboard from "./SellerDashboard";
import LikedServicesComponent from "./LikedServicesComponent";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

type TabType = "purchases" | "listings" | "following" | "likes";

const MyPageComponent = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const initialTab = (searchParams.get('tab') as TabType) || "purchases";
    const [activeTab, setActiveTab] = useState<TabType>(initialTab);

    const tabs: { key: TabType; label: string; icon: string }[] = [
        { key: "purchases", label: "예약한 시간", icon: "🛒" },
        { key: "listings", label: "판매 관리", icon: "📊" },
        { key: "following", label: "팔로잉", icon: "👥" },
        { key: "likes", label: "좋아요", icon: "❤️" },
    ];

    const renderTabContent = () => {
        switch (activeTab) {
            case "purchases":
                return <BookingListComponent />;
            case "listings":
                return <SellerDashboard />;
            case "following":
                return <FollowingComponent />;
            case "likes":
                return <LikedServicesComponent />;
            default:
                return null;
        }
    };

    return (
        <div className="animate-fadeUp">
            {/* Profile card */}
            <div className="bg-white rounded-2xl overflow-hidden mb-5 mobile:rounded-none">
                <ProfileComponent />
            </div>

            {/* Tab bar */}
            <div className="flex gap-2 mb-5 mobile:px-4 overflow-x-auto scrollbar-hide">
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        className={`flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-[13px] font-bold transition-all whitespace-nowrap ${
                            activeTab === tab.key
                                ? "bg-achromatic-900 text-white"
                                : "bg-white text-achromatic-400 hover:text-achromatic-600"
                        }`}
                    >
                        <span>{tab.icon}</span>
                        {tab.label}
                    </button>
                ))}

                {activeTab === "listings" && (
                    <button
                        onClick={() => navigate("/service/new")}
                        className="ml-auto px-4 py-2.5 bg-gradient-to-r from-primary-500 to-violet-500 text-white rounded-xl text-[13px] font-bold
                            hover:shadow-lg hover:shadow-primary-500/20 transition-all whitespace-nowrap"
                    >
                        + 시간 등록
                    </button>
                )}
            </div>

            {/* Content */}
            <div className="bg-white rounded-2xl overflow-hidden mobile:rounded-none">
                {renderTabContent()}
            </div>
        </div>
    );
}

export default MyPageComponent;